import React from "react"
import { Grid, Tooltip } from "@material-ui/core"
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
} from "App/Component/ui"
import {
  defaultDateInputDisplay,
  defaultToastError,
  isNull,
  scrollToTop,
  today,
} from "App/utils/helpers"
import { useSelector } from "react-redux"
import { messageError } from "utils/all"
import { getBpjs } from "pages/WsBridging/Peserta/Bpjs/ui/helpers"
import { SelectIcon } from "App/Assets"

export default function FormAsuransi({ formData, setFormData, handleChange }) {
  const { master } = useSelector((state) => state)
  const [loading, setLoading] = React.useState(false)
  const handleClickSearchSNikByNoKartu = async () => {
    if (isNull(formData.insurance_number)) {
      return defaultToastError("Harap masukkan nomor asuransi !")
    }
    setLoading(true)
    const response = await getBpjs(
      formData.insurance_number,
      defaultDateInputDisplay(today(true), false),
    )

    if (response.state) {
      const dataRes = response.data.nik
      setFormData({
        ...formData,
        nik: dataRes,
      })
      setLoading(false)
      scrollToTop();
    } else {
      setLoading(false)
      defaultToastError(response.message)
    }
  }
  return (
    <>
      <p className="fw-600 mt-2">ASURANSI</p>
      <div className="mt-1">
        <Grid container spacing={1}>
          <Grid item sm={4}>
            <InputOptionMaster
              name="company_id"
              label="PERUSAHAAN"
              id="company_id"
              withSearch={true}
              data={master.perusahaan.list_select}
              value={formData.company_id}
              labelValue={formData.company_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    company_id: null,
                    company_name: "Pilih Perusahaan",
                  })
                } else {
                  setFormData({
                    ...formData,
                    company_id: e.value,
                    company_name: e.label,
                  })
                }
              }}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name="insurance_id"
              label="ASURANSI"
              id="insurance_id"
              withSearch={true}
              data={master.asuransi.list_select}
              value={formData.insurance_id}
              labelValue={formData.insurance_name}
              error={true}
              message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    insurance_id: null,
                    insurance_name: "Pilih Asuransi",
                  })
                } else {
                  setFormData({
                    ...formData,
                    insurance_id: e.value,
                    insurance_name: e.label,
                  })
                }
              }}
            />
          </Grid>

          <Grid item sm={4}>
            <div
              style={{
                display: "flex",
              }}
            >
              <InputTextMaster
                name="insurance_number"
                label="NO ASURANSI/BPJS"
                id="insurance_number"
                placeholder="No Asuransi/BPJS"
                value={formData.insurance_number}
                onChange={handleChange("insurance_number")}
                disabled={loading}
                error={true}
                message={"Selain umum, wajib diisi"}
              />

              <Tooltip
                title={"Cari NIK dengan No. Kartu BPJS"}
                aria-label="search"
              >
                <div>
                  <MasterButton
                    type={"button"}
                    color={
                      loading
                        ? "secondary"
                        : formData.insurance_id === 2 &&
                          formData?.insurance_number?.length > 0
                        ? "lightgreen"
                        : "secondary"
                    }
                    name=""
                    size="sm"
                    withIcon={true}
                    onClick={
                      loading
                        ? "secondary"
                        : formData.insurance_id === 2 &&
                          formData?.insurance_number?.length > 0
                        ? () => handleClickSearchSNikByNoKartu()
                        : () => {}
                    }
                    style={{
                      marginTop: "1.5rem",
                      width: "32px",
                      height: "32px",
                    }}
                    icon={
                      <SelectIcon
                        width="16px"
                        height="16px"
                        style={{
                          marginLeft: "-0.5rem",
                        }}
                      />
                    }
                  />
                </div>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  )
}
